/**
 * HealthOverview Section Component
 *
 * Displays health status overview with bands (Good/Watch/Poor/Critical).
 */

import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@mui/material'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import { HealthOverview as HealthOverviewType } from '../../../../../services/reportsApi'
import Metric from '../Metric'

interface HealthOverviewProps {
  data: HealthOverviewType
  newExceptionsCount: number
}

const HealthOverview: React.FC<HealthOverviewProps> = ({ data, newExceptionsCount }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <HealthAndSafetyIcon color="primary" />
          <Typography variant="h6" component="h2">
            Health Overview
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Metric
              label="Good"
              value={data.totals['Good'] || 0}
              color="#2e7d32"
            />
          </Grid>
          <Grid item xs={3}>
            <Metric
              label="Watch"
              value={data.totals['Watch'] || 0}
              color="#ed6c02"
            />
          </Grid>
          <Grid item xs={3}>
            <Metric
              label="Poor"
              value={data.totals['Poor'] || 0}
              color="#d32f2f"
            />
          </Grid>
          <Grid item xs={3}>
            <Metric
              label="Critical"
              value={data.totals['Critical'] || 0}
              color="#b71c1c"
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Typography variant="body2" color="text.secondary">
          New exceptions detected: {newExceptionsCount}
        </Typography>

        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <Button
            component={RouterLink}
            to="/admin/health-scores"
            size="small"
          >
            View Health Scores
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default HealthOverview
